import { IFeature } from 'mod/featureV2/interface';
import { stickyTopBar, stickyTopBar2 } from './pc/stickyTopBar';
import { productBanner, productBanner2 } from './m/productBanner';
import { overlayBanner } from './m/overlayBanner';
import { banner } from './pc/banner';
import { anchorsBanner } from './m/anchorsBanner';
import { swiperToggleBanner } from './m/swiperToggleBanner';
import { collapse, collapse2 } from './pc/collapse';
import { techSpecs, techSpecs2 } from './pc/techSpecs';
import { swiperReviews, swiperReviews2 } from './pc/swiperReviews';
import { buyButton, buyButton2 } from './pc/buyButton';
import { waterFall } from './m/waterFall';
import { tabsProducts } from './pc/tabsProducts';
import { swiperPicTxt } from './m/swiperPicTxt';
import { article } from './pc/article';
import { animation } from './pc/animation';
import { scaleVideo } from './pc/scaleVideo';
import { parallax1, parallax2, parallax3  } from './pc/parallax';
import { backToTop } from './pc/backToTop';

export const mockM: IFeature[] = [
    stickyTopBar,
    stickyTopBar2,
    productBanner,
    productBanner2,
    overlayBanner,
    banner,
    anchorsBanner,
    swiperToggleBanner,
    collapse,
    collapse2,
    techSpecs,
    techSpecs2,
    swiperReviews,
    swiperReviews2,
    buyButton,
    buyButton2,
    waterFall,
    tabsProducts,
    swiperPicTxt,
    article,
    animation,
    scaleVideo,
    parallax1,
    parallax2,
    parallax3,
    backToTop,
];